import React from 'react';
import { AllieText } from '../Text';
import { TooltipContainer, TooltipContent } from './DarkTooltip.styles';
import { DarkTooltipProps } from './DarkTooltip.types';

export const DarkTooltip: React.FC<DarkTooltipProps> = ({ 
  text, 
  children, 
  disabled,
  side = 'top',
  alignment = 'center',
  style,
  className
}) => {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <TooltipContainer>
      {children}
      <TooltipContent 
        side={side} 
        alignment={alignment}
        style={style} className={className}
      >
        <AllieText type="body3" color="white" weight={600}>
          {text}
        </AllieText>
      </TooltipContent>
    </TooltipContainer>
  );
};
